export enum KnowledgePlayerStatus {
	IN_PROGRESS = 'in_progress',
	WIN = 'win',
	LOSE = 'lose',
	DRAW = 'draw',
}

export interface BattlePlayerDTO {
	user_id: string;
	imported_id: string;
	avatar: string | null;
	firstname: string;
	surname: string;
	score: number | null;
	result: KnowledgePlayerStatus | null;
	localisations: string;
	is_opponent?: 0 | 1;
}

export default class BattlePlayer {
	private _userId: string;
	private _importedId: string;
	private _avatar: string | null;
	private _firstname: string;
	private _surname: string;
	private _score: number | null;
	private _result: KnowledgePlayerStatus | null;
	private _localisations: string;
	private _isOpponent: boolean | undefined;

	constructor(battlePlayer: BattlePlayerDTO) {
		this._userId = battlePlayer.user_id;
		this._importedId = battlePlayer.imported_id;
		this._avatar = battlePlayer.avatar;
		this._firstname = battlePlayer.firstname;
		this._surname = battlePlayer.surname;
		this._score = battlePlayer.score;
		this._result = battlePlayer.result;
		this._localisations = battlePlayer.localisations;
		this._isOpponent = battlePlayer.is_opponent === undefined ? undefined : Boolean(battlePlayer.is_opponent);
	}

	get userId() {
		return this._userId;
	}

	get importedId() {
		return this._importedId;
	}

	get avatar() {
		return this._avatar;
	}

	get firstname() {
		return this._firstname;
	}

	get surname() {
		return this._surname;
	}

	get score() {
		return this._score || 0;
	}

	get result() {
		return this._result;
	}

	get originalScore() {
		return this._score;
	}

	get localisations() {
		return this._localisations;
	}

	/**
	 * `undefined` when the API did not send the flag (e.g. the my-kpi-battles list).
	 */
	get isOpponent() {
		return this._isOpponent;
	}
}
